import { render, staticRenderFns } from "./WidgetProfiles.vue?vue&type=template&id=4f68fd69&"
import script from "./WidgetProfiles.vue?vue&type=script&lang=js&"
export * from "./WidgetProfiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports